/**
 * DraftMarker — "DRAFT" chip + PR link for a pending eval task.
 *
 * A draft task was proposed by the eval-PR agent and is waiting on its
 * regression-test PR: merged → the task turns active, closed → the draft
 * disappears. The chip is a muted hairline badge (never a status tint —
 * pending isn't success or failure) and the link opens the PR itself.
 */

import { Badge } from '@/components/ui/badge'

/**
 * NewMarker — "NEW" chip for an active task inside its newness window
 * (see newTask.ts). Outline rather than filled: it flags recency, not a
 * pending state, so it reads lighter than DRAFT.
 */
export function NewMarker(): React.JSX.Element {
  return <Badge variant="outline">New</Badge>
}

export function DraftMarker({ prUrl }: { prUrl: string | null }): React.JSX.Element {
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      <Badge variant="secondary">Draft</Badge>
      {prUrl !== null && (
        <a
          href={prUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Open the pull request proposing this task"
          className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground hover:text-primary hover:underline"
        >
          PR ↗
        </a>
      )}
    </span>
  )
}
